/* eslint-disable no-unused-vars */
import { Scene, Input } from "phaser";
import {
    backStaticAnimation, leftStaticAnimation, lightstickAnimation, mapHandler, reposeAnimation,
    rightStaticAnimation, turnStaticAnimation, upStaticAnimation, walkAnimation
} from '../../phaser/create';
import { walkHandler, setLastMovement, directionHandler, randomDirection, lightstickHandler } from '../../phaser/update';
import FullScreen from "../../phaser/components/fullScreen";
import PauseButton from "../../phaser/components/pauseButton";
import LightstickCounter from "../../phaser/components/lightstickCounter";
import SettingsButton from "../../phaser/components/settingsButton";
import { addButtonMove } from "../../phaser/components/buttonMove";
import ButtonPressed from "../../phaser/components/buttonPressed";
import HealthBar from "../../phaser/components/healthBar";
import HelpButton from "../../phaser/components/helpButton";
import Joystick from "../../phaser/components/joystick";

let characterSelected;
let objNames = {};
let upRectangle;
let downRectangle;
let leftRectangle;
let rightRectangle;
let gameSettings;
let defaultSettings = 1;
let hearts = 1;
let totalHearts = 1;
let redHeartsObject = [];
let blackHeartsObject = [];
let cursors;
let instructionsHandler = 0;
let enemyShow = null;
let enemyYShow = null;
let intervalEnemy = null;
let startKill = false;
let countFinal = 0;
let scrollFactor = 2;
let hasLightstick = false;
let width = 0;
let totalTimer = 90000;
let isPause = false;
let lastCoordenates = null;
export default class Game12 extends Scene {

    constructor() {
        super({ key: "Game12" });
    }
    init(data) {
        characterSelected = data.characterSelected;
        lastCoordenates = data.lastCoordenates;

        this.enemies = []
        // hasLightstick = false;
        redHeartsObject = [];
        blackHeartsObject = [];
        hearts = 1;
        clearInterval(intervalEnemy);
        clearInterval(this.countdown);
        clearInterval(this.intervalBulletRight)
        intervalEnemy = null;
        this.countdown = null;
        this.intervalBulletRight = null;
        this.startAll = false;
        totalTimer = 90000
        this.events.off('buttonNext-dialogModal');
        setLastMovement('down');
        this.canDownLife = 0;
    }

    preload() {
        if (this.sys.game.device.os.desktop) {
            console.log("desktop")
            this.isMobile = false;
        }
        else {
            this.isMobile = true;

            console.log("mobile")
        }
        cursors = this.input.keyboard.createCursorKeys();
    }

    create() {

        width = this.scale.width;
        const height = this.scale.height;
        const totalWidth = width * 20;

        const w = this.textures.get('background-game12').getSourceImage().width;
        const count = Math.ceil(totalWidth / w) * 2;
        let p = 0;
    
        for (let i = 0; i < count; i++) {
            const m = this.add.image(p, -30, 'background-game12')
                .setOrigin(1,0).setScale(2)
                .setScrollFactor(2)

            p += (m.width*2);
        }


        this.spaceBar = this.input.keyboard.addKey(Input.Keyboard.KeyCodes.SPACE);
        this.pauseButton = this.input.keyboard.addKey(Input.Keyboard.KeyCodes.P);
        this.dialogModal = this.plugins.get('dialogModal');

        gameSettings = localStorage.getItem('sound');
        if (gameSettings === null) {
            localStorage.setItem('sound', 1);
            gameSettings = defaultSettings;
        }

        // this.dialogModal._createWindow(this, 'random-character-start', null, true)
        this.dialogModal._createImageDialog(this, 'random-character-start');
        this.showingInstruction = true;
        this.dialogModal.setText("Who are you? \nHonestly, I don't care. \nAll I know is that I will fight for us.".toUpperCase(), `${characterSelected}-hallway`,false, false)


        this.events.on('pause', () => {
            if(this.joystickManager) {
                this.joystickManager.pause();

            }
            isPause = false;
            this.startKill = true;
            this.startAll = true;
        });

        this.events.on(`resume`, (data, args) => {
            if (args) {
                this.ppalSong.stop();
                this.scene.stop();
                if (args.goHome) {
                    if(this.joystickManager) {
                        this.joystickManager.destroyTest();
                        this.joystickManager = null;
                    }
                    this.events.off('buttonNext-dialogModal');
                    
                    this.scene.start(`Hallway`, { characterSelected: characterSelected, loadAgain: true });
                }
                
                if (args.goStart) {
                    if(this.joystickManager) {
                        this.joystickManager.destroyTest();
                        this.joystickManager = null;
                    }
                    this.events.off('buttonNext-dialogModal');
                    
                    this.scene.start(`Start`);
                }
            } else {
                isPause = false;
                this.sound.mute = false;
                this.startKill = true;
                this.startAll = true;

                if(!this.showingInstruction) {
                    this.startAll = true;
                }

                if(this.isMobile) {
                    if(this.joystickManager) {
                        this.joystickManager.show();
                    }
                }

                gameSettings = localStorage.getItem('sound');
                if (gameSettings === '0') {
                    if (this.ppalSong.isPlaying) {
                        this.ppalSong.stop()
                    }
                } else {
                    if (!this.ppalSong.isPlaying) {
                        this.ppalSong.play();
                    }
                }
            }
        });

        this.ppalSong = this.sound.add(`maisonSong`, { loop: false, volume: 0.2 });
        if (gameSettings === '1') {
            this.ppalSong.play();
        }

        upRectangle = this.add.rectangle(0, 0, width, 240).setOrigin(0).setScrollFactor(0);
        this.physics.add.existing(upRectangle);
        upRectangle.body.collideWorldBounds = true;

        downRectangle = this.add.rectangle(0, height, width, 10).setOrigin(0, 1).setScrollFactor(0);
        this.physics.add.existing(downRectangle);
        downRectangle.body.collideWorldBounds = true;

        leftRectangle = this.add.rectangle(0, 0, 70, height).setOrigin(0).setScrollFactor(0)
        this.physics.add.existing(leftRectangle);
        leftRectangle.body.collideWorldBounds = true;

        rightRectangle = this.add.rectangle(width, 0, 70, height).setOrigin(0).setScrollFactor(0)
        this.physics.add.existing(rightRectangle);
        rightRectangle.body.collideWorldBounds = true;

        this.countdownText = this.add.bitmapText((this.cameras.main.worldView.x + this.cameras.main.width / 2) + 60, 16, 'pixelfont',`${this.convertTimer()}`.toUpperCase(), 10, 1).setTint(0xFFFFFF).setDepth(1).setOrigin(1, 0).setScrollFactor(0).setScale(1.5);
        this.countdownText.visible = false;

        objNames[characterSelected] = this.physics.add.sprite(width / 2, 280, `${characterSelected}-game12`, 4).setScrollFactor(0);
        objNames[characterSelected].body.setCollideWorldBounds(true);
        objNames[characterSelected].setScale(2);
        objNames[characterSelected].setImmovable();

        walkAnimation(this, `${characterSelected}-game12`);
        reposeAnimation(this, `${characterSelected}-game12`);
        rightStaticAnimation(this, `${characterSelected}-game12`);
        lightstickAnimation(this, `${characterSelected}-game12`);

        this.hp = new HealthBar(this, objNames[characterSelected].x - 290, objNames[characterSelected].y - 275);
        this.hp.setVisible(false);
        this.hp.setScrollFactor(0);

        this.deadSprite = this.physics.add.sprite(0, 0, `humo-game12`).setScale(2).setScrollFactor(0).setVisible(false);
        this.anims.create({
            key: `deadSpriteAnimation`,
            frames: this.anims.generateFrameNumbers('humo-game12', { start: 0, end: 17 }),
            frameRate: 8,
            repeat: -1
        });

        this.enemy1 = this.physics.add.sprite(40, 310, `enemy1-game12`).setScale(2).setScrollFactor(0).setVisible(false);
        this.enemy2 = this.physics.add.sprite(width - 40, 310, `enemy2-game12`).setScale(2).setScrollFactor(0).setVisible(false);
        walkAnimation(this, `enemy1-game12`);
        walkAnimation(this, `enemy2-game12`);

        this.bulletLeft = this.physics.add.sprite(0, 0, `bullet-left-game12`).setScrollFactor(0).setVisible(false).setActive(false);
        this.bulletRight = this.physics.add.sprite(0, 0, `bullet-right-game12`).setScrollFactor(0).setVisible(false).setActive(false);

        this.physics.add.collider(objNames[characterSelected], upRectangle);
        this.physics.add.collider(objNames[characterSelected], downRectangle);
        this.physics.add.collider(this.enemy1, upRectangle);
        this.physics.add.collider(this.enemy2, upRectangle);
        this.physics.add.collider(this.enemy1, downRectangle);
        this.physics.add.collider(this.enemy2, downRectangle);
        this.physics.add.collider(objNames[characterSelected], leftRectangle);
        this.physics.add.collider(objNames[characterSelected], rightRectangle);

        this.physics.add.collider(this.bulletLeft, objNames[characterSelected], () => {
            if(this.bulletLeft.active) {
                this.canDownLifeLeft+=1;
                this.bulletLeft.visible = false;
                this.bulletLeft.active = false;
                this.deadSprite.visible = true;
                this.deadSprite.anims.play(`deadSpriteAnimation`, true);
    
                if (this.hp.decrease(10) && this.canDownLifeLeft === 1) {    
                    this.updateCounter();
    
                }
    
                setTimeout(() => {
                    this.deadSprite.visible = false;
                    this.bulletLeft.active = true;
    
                    this.canDownLife = 0;
                }, 500);

            }
        }, null, this);

        this.physics.add.collider(this.bulletRight, objNames[characterSelected], () => {
            if(this.bulletRight.active) {
                this.bulletRight.visible = false;
                this.bulletRight.active = false;
                this.deadSprite.visible = true;
                this.deadSprite.anims.play(`deadSpriteAnimation`, true);
                this.canDownLife+=1;
        
                if (this.hp.decrease(10) && this.canDownLife === 1) {
                    this.updateCounter();
    
                }
    
                setTimeout(() => {
                    this.deadSprite.visible = false;
                    this.bulletRight.active = true;
    
                    this.canDownLife = 0;
                }, 500);

            }
        }, null, this);

        let x = 0;
        let y = 16;
        for (let i = 0; i < totalHearts; i++) {
            if (i === 0) {
                x += 40;
            } else {
                x += 30;
            }
            blackHeartsObject.push(this.add.image(x, y, `heartBlack`, 0).setScale(3).setOrigin(1, 0).setScrollFactor(0));
            redHeartsObject.push(this.add.image(x, y, `heartRed`, 0).setScale(3).setOrigin(1, 0).setScrollFactor(0));
        }

        this.events.on('buttonNext-dialogModal', (data) => {
            instructionsHandler++;
            if (data.id === 'random-character-start') {
                this.dialogModal.close();
                this.countdownText.visible = true;
                this.countdown = setInterval(() => {
                    if (!isPause) {
                        totalTimer -= 1000;
                    }
                    if (totalTimer <= 0) {
                        this.startAll = false;
                        this.startKill = false;
                        clearInterval(this.countdown);
                        clearInterval(intervalEnemy)
                        clearInterval(this.intervalBulletRight);
                        objNames[characterSelected].setVelocity(0);
                        this.cameras.main.fade(1000, 0, 0, 0, false, (cam, progress) => {
                            setLastMovement('down');
                            objNames[characterSelected].anims.play(`repose-${characterSelected}-game12`, true);
                            this.enemy1.setVisible(false);
                            this.enemy2.setVisible(false);
                            this.hp.setVisible(false);
                            this.countdownText.setVisible(false);
                            // objNames[characterSelected].setFrame(4);
                            // objNames[characterSelected].active = false;
                            if (progress === 1) {
                                objNames[characterSelected].setPosition(width / 2, 270);
                                // footsteps.stop();
                                this.cameras.main.fadeIn();
                                objNames[characterSelected].anims.play(`lightstick-${characterSelected}-game12`, true);
                                setTimeout(() => {
                                    // this.dialogModal._createWindow(this, 'random-character-finish', null, true)
                                    this.dialogModal._createImageDialog(this, 'random-character-finish');
                                    this.showingInstruction = true;
                                    this.dialogModal.setText("La maison, la, la, la maison".toUpperCase(), `${characterSelected}-hallway`,false, false)
                                }, 3000);
                            }
                        });
                    }
                }, 1000);
                this.startAll = true;
                this.showingInstruction = false;

                if(this.isMobile) {
                    this.joystickManager = new Joystick(objNames[characterSelected], `${characterSelected}-game12`, 300);
                    this.joystickManager.createJoystick();
                    this.joystickManager.activate(hasLightstick, true);
                }
                instructionsHandler = 0;
                this.hp.setVisible(true);
                intervalEnemy = setInterval(() => {
                    if (!this.startKill && !isPause) {

                        this.enemy1.setVelocity(0, this.generateRandomNumber(-200, 200));


                        setTimeout(() => {
                            this.enemy2.setVelocity(0, this.generateRandomNumber(-200, 200))

                        }, 1000);

                    }

                }, 1000);

                this.intervalBulletRight = setInterval(() => {
                    if (!this.startKill && !isPause) {
                        this.bulletLeft.setPosition(this.enemy2.x - 20, this.enemy2.y + 10);
                        this.bulletLeft.setActive(true).setVisible(true);
                        this.bulletLeft.setVelocity(-600, 0);
                        setTimeout(() => {
                            this.bulletRight.setPosition(this.enemy1.x + 20, this.enemy1.y + 10);
                            this.bulletRight.setActive(true).setVisible(true);
                            this.bulletRight.setVelocity(600, 0);

                        }, 1000);
                    }
                }, 3000);
            }

            if(data.id === 'random-character-finish') {
                this.dialogModal.close();
                clearInterval(intervalEnemy)
                clearInterval(this.intervalBulletRight)
                clearInterval(this.countdown);
                intervalEnemy = null;
                this.intervalBulletRight = null;
                this.ppalSong.stop();
                this.scene.stop();
                this.events.off('buttonNext-dialogModal');

                if(this.joystickManager) {
                    this.joystickManager.destroyTest();
                    this.joystickManager = null;
                }

                if (hearts > 0) {
                    let total = JSON.parse(localStorage.getItem('noL'));
                    if (total) {
                        if (!total.includes(12)) {
                            total.push(12);
                            localStorage.setItem('noL', JSON.stringify(total));

                        }
                    } else {
                        localStorage.setItem('noL', JSON.stringify([12]));
                    }
                    this.scene.start(`Win`, { characterSelected: characterSelected, level: 12, lastCoordenates });
                } else {
                    this.scene.start(`GameOver`, { characterSelected: characterSelected, level: 12, lastCoordenates });
                }
            }
        });

        if (this.isMobile) {

            this.buttonAction = new ButtonPressed(this, 700, 500 - 51, `buttonAction`);
            this.buttonAction.setScale(2);
            this.add.existing(this.buttonAction);
        }


        this.lightstickCounter = new LightstickCounter(this);
        this.buttonFullscreen = new FullScreen(this);
        this.buttonSettings = new SettingsButton(this);
        this.buttonPause = new PauseButton(this, characterSelected);
        this.buttonHelp = new HelpButton(this);


        window.addEventListener("blur", () => {
            isPause = true;
            this.startKill = false;
            this.startAll = false;
            this.buttonPause.pauseByEvent();
        });

        // document.addEventListener('visibilitychange', () => {
        //     if (document.visibilityState !== 'visible') {
        //         isPause = true;

        //         this.startKill = false;
        //         this.startAll = false;
        //         this.buttonPause.pauseByEvent();
        //     }
        // });
    }

    convertTimer() {
        let seconds;
        let minutes;

        minutes = Math.floor((totalTimer / 60000));
        seconds = ((totalTimer % 60000) / 1000).toFixed(0);
        seconds = (seconds < 10 ? '0' : '') + seconds;

        return `${minutes} : ${seconds} ${minutes > 0 ? "MIN" : "SEG"}`;
    }

    updateCounter() {
        this.tweens.add({
            targets: redHeartsObject[hearts - 1],
            alpha: 0,
            scaleX: 0,
            scaleY: 0,
            ease: 'Linear',
            duration: 200
        });

        //create a timeline of tweens for the heart outline so it shrinks then grows back
        var heartsTimeline = this.tweens.createTimeline();

        //this is the heart outline scaling down
        heartsTimeline.add({
            targets: blackHeartsObject[hearts - 1],
            scaleX: 1.5,
            scaleY: 1.5,
            ease: 'Power1',
            duration: 200
        });

        //and then back
        heartsTimeline.add({
            targets: blackHeartsObject[hearts - 1],
            scaleX: 3,
            scaleY: 3,
            ease: 'Power1',
            duration: 200
        });
        //play the timeline straight away
        heartsTimeline.play();
        // redHeartsObject[hearts-1].destroy();
        hearts -= 1;
        if (hearts > 0) {
            this.hp.restartBar();
        }
        setTimeout(() => {
            if (hearts <= 0) {
                // this.timer.destroy();
                clearInterval(intervalEnemy)
                clearInterval(this.intervalBulletRight)
                clearInterval(this.countdown);
                this.cameras.main.fade(1000, 0, 0, 0, false, (cam, progress) => {
                    if (progress === 1) {
                        // footsteps.stop();
                        intervalEnemy = null;
                        this.intervalBulletRight = null;
                        this.ppalSong.stop();
                        this.scene.stop();
                        if(this.joystickManager) {
                            this.joystickManager.destroyTest();
                            this.joystickManager = null;
                        }
                        this.events.off('buttonNext-dialogModal');
                        this.scene.start(`GameOver`, { characterSelected: characterSelected, level: 12, lastCoordenates });
                    }
                });
            }
            // handleDamage = false;

        }, 1000);

    }

    generateRandomNumber(min, max) {
        return Math.floor(Math.random() * (max - min + 1) + min);
    }


    update() {

        const cam = this.cameras.main;
        let speed = 3;
        let speedMona = 100;
        if (this.startAll && !startKill) {

            if (this.countdownText.visible) {
                this.countdownText.setText(this.convertTimer());
            }

            if (objNames[characterSelected].active) {
                if (this.isMobile) {
                    if(this.joystickManager) {
                        this.joystickManager.show();
                    }               
                 } else {
                    walkHandler(cursors, objNames[characterSelected], 300, `${characterSelected}-game12`, hasLightstick, true);
                }
            }

            this.hp.updatePosition(objNames[characterSelected].x - 150, objNames[characterSelected].y - 100);
            if (this.deadSprite.visible) {
                this.deadSprite.setPosition(objNames[characterSelected].x, objNames[characterSelected].y);
            }

            if (totalTimer > 0) {

                this.enemy1.setVisible(true);
                this.enemy2.setVisible(true);
                this.enemy1.anims.play(`right-enemy1-game12`, true);
                this.enemy2.anims.play(`left-enemy2-game12`, true);

                if (this.isMobile) {
                    // if (this.joystickManager?.isToLeft) {
                    //     cam.scrollX -= speed
                    // } else {
                        cam.scrollX += speed;


                    // }
                } else {
                    // if (cursors.left.isDown) {
                    //     cam.scrollX -= speed
                    // } else {
                        cam.scrollX += speed;

                    // }

                }

            } else {
                this.enemy1.setVisible(false);
                this.enemy2.setVisible(false);
            }
        } else {
            if(this.isMobile) {
                if(this.joystickManager) {

                    this.joystickManager.pause();
                }
            }
        }

        if (!this.isMobile && this.pauseButton.isDown) {
            this.startKill = false;
            this.startAll = false;
            isPause = true;
            this.scene.launch('Pause', { scene: 'Game12' });
            this.scene.pause();

        }

    }

}